var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrap"},[_vm._t("default"),_c('el-button',{staticClass:"export-pdf-btn",attrs:{"size":"mini","icon":"document"},on:{"click":_vm.doExport}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }